import * as React from 'react';

function getTextContent(node: React.ReactNode): string {
  if (typeof node === 'string') return node;
  if (Array.isArray(node)) return node.map(getTextContent).join('');
  if (React.isValidElement(node))
    return getTextContent(
      (node.props as { children?: React.ReactNode }).children,
    );
  return '';
}

function slugify(text: string): string {
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '');
}

type Props = React.HTMLAttributes<HTMLHeadingElement> & {
  as: 'h1' | 'h2' | 'h3' | 'h4';
};

export const AnchorHeading: React.FC<Props> = ({
  as: Tag,
  children,
  ...props
}) => {
  const id = slugify(getTextContent(children));
  return (
    <Tag id={id} {...props} style={{ scrollMarginTop: '80px' }}>
      <a
        href={`#${id}`}
        className="heading-anchor"
        aria-label="Link to this section"
      >
        {children}
        <span className="heading-anchor-symbol" aria-hidden="true">
          #
        </span>
      </a>
    </Tag>
  );
};
